import React, { useRef } from 'react';

export default function OtpInput({ value, onChange, disabled = false }) {
  const refs = useRef([]);
  const digits = String(value || '').padEnd(6, ' ').slice(0, 6).split('');

  const setValue = (next) => onChange(next.replace(/\D/g, '').slice(0, 6));

  const handleChange = (index, raw) => {
    const clean = raw.replace(/\D/g, '');
    if (!clean) {
      const next = String(value || '').split('');
      next[index] = '';
      setValue(next.join(''));
      return;
    }
    const next = String(value || '').padEnd(6, ' ').split('');
    clean.slice(0, 6 - index).split('').forEach((digit, offset) => {
      next[index + offset] = digit;
    });
    const finalValue = next.join('').replace(/\s/g, '');
    setValue(finalValue);
    const focusIndex = Math.min(index + clean.length, 5);
    refs.current[focusIndex]?.focus();
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !digits[index].trim() && index > 0) {
      refs.current[index - 1]?.focus();
    }
    if (e.key === 'ArrowLeft' && index > 0) refs.current[index - 1]?.focus();
    if (e.key === 'ArrowRight' && index < 5) refs.current[index + 1]?.focus();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    setValue(pasted);
    refs.current[Math.min(pasted.length, 5)]?.focus();
  };

  return (
    <div className="otp-box-row" onPaste={handlePaste}>
      {digits.map((digit, index) => (
        <input
          key={index}
          ref={el => refs.current[index] = el}
          className="otp-box"
          inputMode="numeric"
          autoComplete={index === 0 ? 'one-time-code' : 'off'}
          maxLength={1}
          value={digit.trim()}
          disabled={disabled}
          onChange={e => handleChange(index, e.target.value)}
          onKeyDown={e => handleKeyDown(index, e)}
          aria-label={`OTP digit ${index + 1}`}
        />
      ))}
    </div>
  );
}
